import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SidebarStateService } from 'src/app/core/services/sidebar-state.service';

@Component({
  selector: 'app-page-title',
  templateUrl: './pagetitle.component.html',
  styleUrls: ['./pagetitle.component.scss']
})
export class PagetitleComponent implements OnInit {
  @Input() breadcrumbItems;
  @Input() title: string;
  @Input() showBackButton: boolean = false;
  @Output() onBackButtonClick = new EventEmitter<void>();

  constructor(private sidebarStateService: SidebarStateService) {}

  ngOnInit() {
  }

  back(){
    this.onBackButtonClick.emit();
  }

  get isSidebarExpanded(): boolean {
    return this.sidebarStateService.isSidebarExpanded;
    
  }

}
